import { PackageSearch } from "lucide-react";
import type { ReactNode } from "react";

export function TableState({
  title,
  description,
  action,
}: {
  title: string;
  description: string;
  action?: ReactNode;
}) {
  return (
    <div className="module-empty">
      <PackageSearch size={28} />
      <strong>{title}</strong>
      <p>{description}</p>
      {action}
    </div>
  );
}
